import $ from 'jquery';

import widgetFactory from '../widgetFactory';

const widgetName = 'ajaxCheck',
  className = 'js-ajaxCheck';

// widget definition
const widget = widgetFactory(widgetName, {
  options: {
    dirtyCheck: true,
    autoSubmit: false,
    autoSubmitTimeout: 2000,
    responseKey: 'message',
    endPoint: '',
    inputAliasName: '',
    inputShouldBeFill: true,
    requestMethod: 'POST',
    resultElement: null,
    onValidCheck: $.noop,
    onErrorCheck: $.noop,
    onCheck: $.noop,
  },

  _create: function () {
    this._super();

    this.isLoading = false;
    this.autoSubmitTimeout = null;
    this.currentCheckedValue = null;

    this.additionalValues = {};

    this.elements = {
      $button: this.element.find('.js-ajaxCheck-button'),
      $field: this.element.find('.js-ajaxCheck-field'),
      $result: this.options.resultElement || this.element.find('.js-ajaxCheck-result'),
      $error: this.element.find('.js-ajaxCheck-error'),
    };

    this._attachEvents();

    this._trigger('onReady', null, { instance: this });

    if (this.options.autoSubmit) {
      this.elements.$button.hide();
    }

    if (!this.isEmpty()) {
      this.checkIt();
    }
  },

  _attachEvents: function () {
    var self = this,
      doCheck = function (event) {
        if (self._trigger('onCheck', event)) {
          self.checkIt();
        }
      };

    this.elements.$button.on('click', function (event) {
      doCheck(event);
    });

    this.elements.$field.on('keypress', function (event) {
      if (event.which === $.ui.keyCode.ENTER) {
        // return
        event.preventDefault();
        self.clean();
        doCheck(event);
      }
    });

    if (this.options.autoSubmit) {
      this.elements.$field
        .on('keydown', function (event) {
          var delay = self.options.autoSubmitTimeout;

          clearTimeout(self.autoSubmitTimeout);

          self.autoSubmitTimeout = setTimeout(function () {
            doCheck(event);
          }, delay);
        })
        .on('blur', function (event) {
          doCheck(event);
        });
    }
  },

  _getData: function () {
    var data = {},
      $field = this.elements.$field;

    if (!this.isEmpty()) {
      data[this.options.inputAliasName || $field.attr('name')] = $field.val();
    }

    if (this.additionalValues) {
      $.extend(data, this.additionalValues);
    }

    return data;
  },

  isDirty: function () {
    return this.elements.$field.val() !== this.currentCheckedValue;
  },

  clean: function () {
    this.currentCheckedValue = null;
  },

  reset: function () {
    this._updateResult('');
    this.elements.$field.val('');
  },

  setValue: function (newValue) {
    this.elements.$field.val(newValue);
  },

  setAdditionalValues: function (values) {
    this.additionalValues = values;
  },

  isEmpty: function () {
    return this.elements.$field.val() === '';
  },

  checkIt: function (force) {
    var self = this,
      endpoint = this.options.endPoint;

    if (force) {
      this.clean();
    }

    if (
      (this.options.inputShouldBeFill && this.isEmpty()) ||
      !endpoint ||
      this.isLoading ||
      (this.options.dirtyCheck && !this.isDirty())
    ) {
      return;
    }

    this.isLoading = true;
    this.element.addClass('is-loading');
    this.currentCheckedValue = this.elements.$field.val();

    this._updateResult('');

    $.ajax({
      type: this.options.requestMethod,
      contentType: 'application/json',
      url: endpoint,
      dataType: 'json',
      data: JSON.stringify(this._getData()),
    })
      .done(function (data) {
        self._updateResult(data[self.options.responseKey]);
        self._trigger('onValidCheck', null, data);
      })
      .fail(function (jqxhr) {
        self.element.addClass('has-error');

        if (jqxhr.responseJSON && jqxhr.responseJSON.errors) {
          self._updateResult(jqxhr.responseJSON.errors, true);
        } else {
          self._updateResult('error.', true);
        }

        self._trigger('onErrorCheck', null);
      })
      .always(function () {
        self.element.removeClass('is-loading');
        self.isLoading = false;
      });
  },

  _updateResult: function (messages, isError) {
    var $element;

    if (messages) {
      $element = isError ? this.elements.$error : this.elements.$result;
      if (!isError) {
        this.elements.$result.html('');
      }
    } else {
      $element = $(this.elements.$error, this.elements.$result);
    }

    if (isError && $.isArray(messages)) {
      messages = '<ul><li>' + messages.join('</li><li>') + '</li></ul>';
    }

    messages = messages.replace(/\n/, '<br>');

    if ($element.is('input')) {
      $element.val(messages);
    } else {
      $element.html(messages);
    }
  },
});

$(function () {
  $('.' + className)[widgetName]();
});

export default widget;
